module.exports = __webpack_public_path__ + "img/dis-r-1.15100459.png";